// extracted by mini-css-extract-plugin
export default {"formControlLabel":"MultipleChoiceToolbar_formControlLabel__ZWQC5","root":"MultipleChoiceToolbar_root__dFg9n"};